import React from "react";
import { Exchange } from "../Components";

export const ExchangeOption = () => {
  return <Exchange />;
};
